import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { MuiCheckbox, AccordionWithArrow } from '../../../../components'
import keyDataArray from './data'
import { Wrapper, CheckBoxWrapper } from './style'

const ColumnSection = ({ onChange, expanded }) => {
  const [checkBoxData, setCheckBoxData] = useState(keyDataArray)

  const onChangeHandler = (e, obj) => {
    const count = checkBoxData.filter(f => f.checked).length
    if (count <= 3 && obj.checked) {
      return false
    }

    const data = checkBoxData.map(d => {
      return { ...d, checked: (d.key === obj.key) ? !d.checked : d.checked }
    })
    setCheckBoxData(data)
    onChange(data.filter(f => f.checked))
  }

  useEffect(() => {
    onChange(checkBoxData.filter(f => f.checked))
  }, [])

  return (
    <Wrapper>
      <AccordionWithArrow title='Column Selection (Select minimum 3 fields)' expanded={expanded} accordionstyle='filter'>
        <CheckBoxWrapper>
          {checkBoxData.map((obj, i) => {
            return (
              <MuiCheckbox key={'keyword__' + i} label={obj.title} value={obj.key} checked={obj.checked} onChange={(e) => onChangeHandler(e, obj)} />
            )
          })}
        </CheckBoxWrapper>
      </AccordionWithArrow>
    </Wrapper>
  )
}

ColumnSection.propTypes = {
  onChange: PropTypes.func,
  expanded: PropTypes.bool
}

export default ColumnSection
